const ANNUL_SALE_ACTION = 'Anular Ticket'
const CREATE_NEW_USER = 'Registrar Cliente'
const CLEAN_TICKET = 'Limpiar Ticket'
const DELETE_WHOLESALE_DISCOUNT = 'Confirmar'
const DELETE_ITEM = 'Eliminar Item'
const DELETE_SUBFAMILY = 'Eliminar Subfamilia'
const DELETE_TAG = 'Eliminar Tag'
export { 
    ANNUL_SALE_ACTION, 
    CREATE_NEW_USER, 
    CLEAN_TICKET, 
    DELETE_WHOLESALE_DISCOUNT, 
    DELETE_ITEM,
    DELETE_SUBFAMILY ,
    DELETE_TAG
}
